// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O2Ia","comment":"styles_comment__3bzSX"};